import React from "react";

import Checkbox from "./Checkbox.styles";
import * as S from "./Td.styles";

interface TdProps extends S.TdProps {
  children: React.ReactNode;
  className?: string;
  onCheckedChanged?: () => void;
  checked?: boolean;
  id?: string;
  label?: string;
}

const Td = ({
  children,
  id,
  onCheckedChanged,
  checked,
  label,
  ...props
}: TdProps) => (
  <S.Layout {...props}>
    {onCheckedChanged && (
      <Checkbox
        id={`checkbox_${id}`}
        forId={`checkbox_${id}`}
        label={label}
        checked={!!checked}
        onCheckedChanged={onCheckedChanged}
      />
    )}
    {children}
  </S.Layout>
);

export default Td;
